import React, { useEffect } from "react";
import styled from "styled-components";
import { Image } from "semantic-ui-react";
import backgroundFooter from "../../assets/images/sprites/background-footer.png";
import gabaMidnight from "../../assets/images/sprites/gabaMidnight.png";
import In from "../../assets/images/sprites/in.svg";
import twitter from "../../assets/images/sprites/twitter.svg";
import { ThemeProps } from "./globalStyles";

export default function Footer() {
  useEffect(()=>{
    const script = document.createElement('script');
  
    script.src = 'https://gaba.activehosted.com/f/embed.php?id=4';
    script.async = true;
  
    document.body.appendChild(script);
  
  },[])

  return (
    <FooterCont>
      <Container1>
        <Paragraph>
          GABA brings together Pre-Health Students past and present to exchange experiences, wisdom and opportunities.
          <br /><br />Discover your learning style and build lifelong connections with others who share your career interests.
        </Paragraph>
        <Container12>
          <Container2>
            <ContainerColumn>
              <Label>Home</Label>
              <Label>How it works</Label>
              <Label>Human stories</Label>
            </ContainerColumn>
            <ContainerColumn>
              <Label>Follow us</Label>
              <div>
                <SocialButton href='https://www.linkedin.com/company/gogabaco/'>
                  <img className='img-In' src={In} alt='img' />
                </SocialButton>
                <SocialButton href='https://twitter.com/goGABAco'>
                  <img className='img-twitter' src={twitter} alt='img' />
                </SocialButton>
              </div>
            </ContainerColumn>
          </Container2>
          {/* <form
            action='https://gogaba.us2.list-manage.com/subscribe/post?u=775b9f2223c9be8c165ae83ae&amp;id=1b473c3f8f'
            method='post'
            id='mc-embedded-subscribe-form'
            name='mc-embedded-subscribe-form'
            className='validate'
            target='_blank'
            noValidate
          >
            <FormSendEmail>
              <Input
                type='email'
                name='EMAIL'
                className='email'
                id='mce-EMAIL'
                placeholder='Enter your email for updates!'
                required
              />

              <div style={{ visibility: "hidden", width: "1px" }}>
                <input
                  type='text'
                  name='b_775b9f2223c9be8c165ae83ae_1b473c3f8f'
                  tabIndex='-1'
                />
              </div>
              <SubmitBtn className='submit-search'>
                Subscribe
              </SubmitBtn>
            </FormSendEmail>
          </form> */}
          <div className="_form_4" />
        </Container12>
      </Container1>
      <Container2>
        <Image
          src={gabaMidnight}
          style={{ width: 42, height: 20 }}
        />
        <Container21>
          <Label>
            Privacy Policy
          </Label>
          <Label>
            Term of services
          </Label>
          <Label>
            Copyright GABA Inc.
          </Label>
        </Container21>
      </Container2>
    </FooterCont>
  );
}

const FooterCont = styled.footer`
  background-image: url(${backgroundFooter});
  background-color: #C9CDD1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Container1 = styled.div`
  width: 100%;
  max-width: 1200px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px #aaa solid;
  padding-bottom: 8px;
  @media (max-width: 520px) {
    flex-direction: column;
  }
`;
const Container2 = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
`;
const Container12 = styled.div`
  width: 40%;
  @media (max-width: 720px) {
    width: 60%
  }
  @media (max-width: 520px) {
    width: 100%
  }
`;
const Container21 = styled.div`
  display: flex;
`;
const ContainerColumn = styled.div`
  display: flex;
  flex-direction: column;
`;
const Label = styled.label`
  padding: 6px 8px;
  color: rgb(17, 23, 65);
  font-size: 14px;
  font-weight: 600;
`;
const Paragraph = styled.p`
  width: 45%;
  padding: 8px;
  color: rgb(17, 23, 65);
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  @media (max-width: 520px) {
    width: 100%
  }
`;
const Input = styled.input`
  height: 40px;
  padding: 0.375rem 3.5rem 0.375rem 1.7rem;
  border-color: #f3f7fe;
  border-radius: 6px;
  border-width: 1px;
  background-color: #fff;
  color: #111741;
  width: 100%;
`;
const SubmitBtn = styled.button`
  border-radius: 2px;
  margin: auto;
  right: 0;
  height: 40px;
  background-color: ${ThemeProps.color.darkBlue};
  color: ${ThemeProps.color.gabaYellow};
  border: none;
  border-radius: 6px;
  margin-left: 8px;
  padding: 0 10px;
`;
const FormSendEmail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 100%;
`;
const SocialButton = styled.a`
  padding: 8px;
`;